import { MoonIcon, SunIcon } from "@heroicons/react/24/outline";
import { useLegacyHeadlinesTheme } from "./useLegacyHeadlinesTheme";

const ICON_BASE = "/images/icons";

const STATUS_ITEMS = [
  { icon: "news", label: "News" },
  { icon: "important", label: "Important" },
  { icon: "release", label: "Data Release" },
  { icon: "commentary", label: "Commentary" },
];

const HINT_ITEMS = [
  { icon: "expand", label: "Click to expand news story details" },
  { icon: "collapse", label: "Click to collapse / hide news story details" },
  { icon: "reaction", label: "Contains market reaction info" },
  { icon: "analysis", label: "Contains analysis" },
];

/**
 * Legend bar reproducing the header key from the legacy headline page, plus a
 * page-local light/dark toggle (defaults to light for legacy users, without
 * touching the app's global theme).
 */
function LegacyLegend() {
  const { theme, toggle } = useLegacyHeadlinesTheme();

  return (
    <div className="lh-legend">
      <div className="lh-legend-group">
        {STATUS_ITEMS.map((item) => (
          <span key={item.icon} className="lh-legend-item">
            <img src={`${ICON_BASE}/${item.icon}.png`} alt="" aria-hidden />
            {item.label}
          </span>
        ))}
      </div>
      <div className="lh-legend-group">
        {HINT_ITEMS.map((item) => (
          <span key={item.icon} className="lh-legend-item">
            <img src={`${ICON_BASE}/${item.icon}.png`} alt="" aria-hidden />
            {item.label}
          </span>
        ))}
      </div>
      <div className="lh-legend-controls">
        <button
          type="button"
          className="lh-theme-toggle"
          onClick={toggle}
          title={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
          aria-label={
            theme === "dark" ? "Switch to light mode" : "Switch to dark mode"
          }
        >
          {theme === "dark" ? <SunIcon /> : <MoonIcon />}
          {theme === "dark" ? "Light" : "Dark"}
        </button>
      </div>
    </div>
  );
}

export default LegacyLegend;
